/**
 * created by yxxyyxyx
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Col, Icon, Input, message, Upload, Table, Button} from 'antd';
import BaseComponent from "../../../../base/BaseComponent";
import UploadWall from "../../../../components/upload/UploadWall";
import ChunkUpload from "../../../../components/upload/ChunkUpload";
import {FILE_TYPE,PIC_TYPE,VIDEO_TYPE,AUDIO_TYPE} from "../../../../constants";
import {applicationName, uuid} from "../../../../utils";
import {getInfoFromLocalStorage} from "../../../../actions";
import {checkFileStatus} from "../../../../actions/upload";
import UpLoad from "./components/upload";
import request from "../../../../base/request";
import moment from 'moment'

const { TextArea } = Input;

export default class AddClue extends BaseComponent {
    static defaultProps = {};
    static propTypes = {

    };

    constructor(props) {
        super(props);
        this.state = {
            clue:{
                title:'',
                type:'img',
                contacts:'',
                content:'',
                contactsWay:'',
                enclosureList:[],
                resourcePictures:[],//线索图片
                resourceVideos:[],//线索视频
                attachments:[],//附件
                submittedCompany:'',//提交单位
                submittedPeople:'',//提交人
                status:'',//状态
            },
            dataSource: [
                {
                    key: '1',
                    name: '胡彦斌',
                    age: 32,
                    address: '西湖区湖底公园1号',
                },
                {
                    key: '2',
                    name: '胡彦祖',
                    age: 42,
                    address: '西湖区湖底公园1号',
                },
            ],

            state: 1,
            size: 10,
            count: 0,
            onChange: () => {
                console.log(1)
            },

        }
    }

    componentWillMount() {


    }
    sysConfigLoadOver() {
        if(this.sysConfig.operation==='add'){
            this.addClue()
        }



    }
    componentDidMount() {


    }
    editClue(){
        // let
    }
    addClue(){
        this.state.clue.title ='';
        this.state.clue.contacts ='';
        this.state.clue.content ='';
        this.state.clue.contactsWay ='';
        this.state.clue.resourceVideos ='';
        this.state.clue.resourcePictures ='';
        this.state.clue.attachments ='';
    }

    render() {
        let {
            operation = 'details',

            submittedCompanyKey="提交单位",
            submittedCompanyShow=true,
            submittedCompanyRequired=true,
            submittedCompanyParam="title",
            submittedCompanyPlaceholder="请输入标题",

            submittedPeopleKey="提交人",
            submittedPeopleShow=true,
            submittedPeopleRequired=true,
            submittedPeopleParam="title",
            submittedPeoplePlaceholder="请输入标题",


            statusKey="状态",
            statusShow=true,
            statusRequired=true,
            statusParam="title",
            statusPlaceholder="请输入标题",

            acceptDepartKey = "接受单位",
            acceptDepartShow=true,
            acceptDepartRequired = true,
            acceptDepartParam="title",
            acceptDepartPlaceholder="请输入标题",


            submittedTimeKey= "提交时间",
            submittedTimeShow=true,
            submittedTimeRequired=true,
            submittedTimeParam= "title",
            submittedTimePlaceholder="请输入标题",

            titleKey = "线索标题",
            titleShow = true,
            titleRequired = true,
            titleParam = "title",
            titlePlaceholder= "请输入"+titleKey,


            contentShow=true,
            contentKey = "线索内容",
            contentRequired = true,
            contentParam =  "content",
            contentPlaceholder= "请输入"+contentKey,

            resourcePicturesRequired =true,
            resourcePicturesShow=true,
            resourcePicturesKey = "线索图片",

            resourceVideosRequired=true,
            resourceVideosShow=true,
            resourceVideosKey ="线索视频",

            attachmentPicturesRequired =true,
            attachmentPicturesShow=true,
            attachmentPicturesKey="附件",


            replyDateKey = "要求回稿时间",
            replyDateShow=false,
            replyDateRequired=true,
            replyDateParam= "replyDate",
            replyDatePlaceholder="请输入标题",

            replyContentShow=false,
            replyContentKey="稿件要求",
            replyContentRequired=true,
            replyContentParam="requireContent",
            replyContentPlaceholder= "请输入",

            createTimeShow=false,
            createTimeKey="创建时间",
            createTimeRequired=true,
            createTimeParam= "createTime",
            createTimePlaceholder="请输入电话号码",

            objectShow=false,
            objectKey="约稿对象",
            objectRequired=true,
            objectParam= "contactsWay",
            objectPlaceholder="请选择",

            showReceiveBtn = false,
            receiveBtnText = "领取",
            showRefuseBtn = false,
            refuseBtnText = "拒绝",

        } = this.sysConfig;
        let {clue,checkedReceive,checkedRefuse} = this.state;
        let record = this.props.record || "";
        if(record){
            this.state.clue =record
        }
        console.log(this.state.clue)
        const columns =  [
            {
                title: '姓名',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: '年龄',
                dataIndex: 'age',
                key: 'age',
            },
            {
                title: '住址',
                dataIndex: 'address',
                key: 'address',
            },
        ];
        const btnStyle = {
            width: "74px",
            height: "32px",
            background: "rgba(255, 255, 255, 0.39)",
            border: "1px solid rgba(0, 0, 0, 0.14901960784313725)",
            borderRadius:"3px",
            textAlign:"center",
            lineHeight:"32px"

        }
        return (
            <div>
                <div style={{display:'flex'}}>
                    { submittedCompanyShow&& <div style={{display:'flex',marginTop:'20px',width:'50%'}}>
                        <div style={{display: 'flex', alignItems: 'center',width:'90px',}}>{ submittedCompanyRequired ? <span style={{color:'red',marginRight:'5px'}}>*</span> : null}{ submittedCompanyKey}:</div>
                        <div  style={{ }}>
                            {operation==='details'?<div  style={{ width:'100%' }}> {clue&&clue[ submittedCompanyParam]}</div>:<Input placeholder={  submittedCompanyPlaceholder }  value={clue&&clue. submittedCompany}
                                                                                                                                     onChange={(e) => {
                                                                                                                                         this.onChange(' submittedCompany', e.target.value)
                                                                                                                                     }}/>}
                        </div>
                    </div>}
                    {submittedPeopleShow&& <div style={{display:'flex',marginTop:'15px',width:'50%'}}>
                        <div style={{width:'90px',display: 'flex', alignItems: 'center'}}>{submittedPeopleRequired ? <span style={{color:'red',marginRight:'5px'}}>*</span> : null}{submittedPeopleKey}:</div>
                        <div >
                            {operation==='details'?<div  style={{ width:'100%' }}> {clue&&clue[submittedPeopleParam]}</div>: <Input placeholder={ submittedPeoplePlaceholder }  value={clue&&clue.submittedPeople}
                                                                                                                                    onChange={(e) => {
                                                                                                                                        this.onChange('submittedPeople', e.target.value)
                                                                                                                                    }}/>}
                        </div>
                    </div>}
                </div>
                <div style={{display:'flex'}}>
                    { submittedTimeShow&& <div style={{display:'flex',marginTop:'20px',width:'50%',alignItems: 'center'}}>
                        <div style={{display: 'flex', alignItems: 'center',width:'90px',}}>{ submittedTimeRequired ? <span style={{color:'red',marginRight:'5px'}}>*</span> : null}{ submittedTimeKey}:</div>
                        <div  style={{ }}>
                            {operation==='details'?<div  style={{ width:'100%' }}> {clue&&clue[ submittedTimeParam]}</div>:<Input placeholder={  submittedTimePlaceholder }  value={clue&&clue.submittedTimeCompany}
                                                                                                                                  onChange={(e) => {
                                                                                                                                      this.onChange(' submittedTime', e.target.value)
                                                                                                                                  }}/>}
                        </div>
                    </div>}
                    {statusShow&& <div style={{display:'flex',marginTop:'15px',width:'50%',alignItems: 'center'}}>
                        <div style={{width:'90px',display: 'flex', alignItems: 'center'}}>{statusRequired ? <span style={{color:'red',marginRight:'5px'}}>*</span> : null}{statusKey}:</div>
                        <div  >
                            {operation==='details'?<div  style={{ width:'100%' }}> {clue&&clue[statusParam]}</div>: <Input placeholder={ statusPlaceholder }  value={clue&&clue.status}
                                                                                                                           onChange={(e) => {
                                                                                                                               this.onChange('status', e.target.value)
                                                                                                                           }}/>}
                        </div>
                    </div>}
                </div>
                <div style={{display:'flex'}}>
                    {acceptDepartShow&& <div style={{display:'flex',marginTop:'20px',width:'50%',alignItems: 'center'}}>
                        <div style={{display: 'flex', alignItems: 'center',width:'90px',}}>{ acceptDepartRequired ? <span style={{color:'red',marginRight:'5px'}}>*</span> : null}{ acceptDepartKey}:</div>
                        <div  style={{ }}>
                            {operation==='details'?<div  style={{ width:'100%' }}> {clue&&clue[acceptDepartParam]}</div>:<Input placeholder={  acceptDepartPlaceholder }  value={clue&&clue.acceptDepartCompany}
                                                                                                                                onChange={(e) => {
                                                                                                                                    this.onChange('acceptDepart', e.target.value)
                                                                                                                                }}/>}
                        </div>
                    </div>}
                    {titleShow&& <div style={{display:'flex',marginTop:'20px',width:'50%',alignItems: 'center'}}>
                        <div style={{display: 'flex', alignItems: 'center',width:'90px',}}>{titleRequired ? <span style={{color:'red',marginRight:'5px'}}>*</span> : null}{titleKey}:</div>
                        <div  style={{ }}>
                            {operation==='details'?<div  style={{ width:'100%' }}> {clue&&clue[titleParam]}</div>:<Input placeholder={ titlePlaceholder }  value={clue&&clue.title}
                                                                                                                         onChange={(e) => {
                                                                                                                             this.onChange('title', e.target.value)
                                                                                                                         }}/>}
                        </div>
                    </div>}
                </div>
                {contentShow&& <div style={{display:'flex',marginTop:'15px'}}>
                    <div style={{width:'90px'}}>{contentRequired ? <span style={{color:'red',marginRight:'5px'}}>*</span> : null}{contentKey}:</div>
                    <div  >
                        {operation==='details'?<div  style={{ width:'100%' }}> {clue&&clue[contentParam]}</div>:    <TextArea
                            value={clue&&clue.content}
                            placeholder={ contentPlaceholder }
                            autoSize={{ minRows: 3, maxRows: 5 }}
                            onChange={(e) => {
                                this.onChange('content', e.target.value)
                            }}
                        />}

                    </div>
                </div>}

                {resourcePicturesShow&& <div style={{display:'flex',marginTop:'15px'}}>
                    <div style={{width:'100px'}}>{resourcePicturesRequired ? <span style={{color:'red',marginRight:'5px'}}>*</span> : null}{resourcePicturesKey}</div>
                    <div style={{ display:"flex",flexWrap:"wrap"}}>
                        <UpLoad   imgHandleChange={
                            this.imgHandleChange}   type="1" fileList={this.state.clue.resourcePictures}></UpLoad>
                    </div>
                </div>}
                {resourceVideosShow&& <div style={{display:'flex'}}>
                    <div style={{width:'100px',}}>{resourceVideosRequired ? <span style={{color:'red',marginRight:'5px'}}>*</span> : null}{resourceVideosKey}</div>
                    <div style={{ display:"flex",flexWrap:"wrap"}}>
                        <UpLoad   imgHandleChange={this.imgHandleChange} type="2" fileList={this.state.clue.resourceVideos}></UpLoad>
                    </div>
                </div>}
                {attachmentPicturesShow&& <div style={{display:'flex',}}>
                    <div style={{width:'100px',display: 'flex', alignItems: 'center'}}>{attachmentPicturesRequired ? <span style={{color:'red',marginRight:'5px'}}>*</span> : null}{attachmentPicturesKey}</div>
                    <div style={{ display:"flex",flexWrap:"wrap"}}>
                        <UpLoad   imgHandleChange={this.imgHandleChange} type="3" fileList={this.state.clue.attachments}></UpLoad>
                    </div>
                </div>}

                {/*以下为约稿详情*/}
                <div style={{display:"flex",justifyContent:"center"}}>
                    {showReceiveBtn && <div style={{...btnStyle,background:checkedReceive?"images/selected.png":""}} onClick={()=>{
                        this.setState({checkedReceive:true,checkedRefuse:false})
                    }}>{receiveBtnText}</div>}
                    {showRefuseBtn && <div style={{...btnStyle,marginLeft:24,background:checkedRefuse?"images/selected.png":""}} onClick={()=>{
                        this.setState({checkedReceive:false,checkedRefuse:true})
                    }}>{refuseBtnText}</div>}
                </div>
                {replyDateShow&& <div style={{display:'flex',marginTop:'20px'}}>
                    <div style={{display: 'flex', alignItems: 'center'}}>{replyDateRequired ? <span style={{color:'red',marginRight:'5px'}}>*</span> : null}{replyDateKey}:</div>
                    <div  style={{ }}>
                        {operation==='details'?<div  style={{ width:'100%' }}> {clue&&moment(clue[replyDateParam]).format('YYYY-MM-DD HH:mm:ss') }</div>:<Input placeholder={ replyDatePlaceholder }  value={clue&&clue.replyDate}
                                                                                                                                                                onChange={(e) => {
                                                                                                                                                                    this.onChange('replyDate', e.target.value)
                                                                                                                                                                }}/>}
                    </div>
                </div>}
                {replyContentShow&& <div style={{display:'flex',marginTop:'20px'}}>
                    <div style={{display: 'flex', alignItems: 'center'}}>{replyContentRequired ? <span style={{color:'red',marginRight:'5px'}}>*</span> : null}{replyContentKey}:</div>
                    <div  style={{ }}>
                        {operation==='details'?<div  style={{ width:'100%' }}> {clue&&clue[replyContentParam]}</div>:<Input placeholder={ replyContentPlaceholder }  value={clue&&clue.replyDate}
                                                                                                                            onChange={(e) => {
                                                                                                                                this.onChange('replyDate', e.target.value)
                                                                                                                            }}/>}
                    </div>
                </div>}
                {createTimeShow&& <div style={{display:'flex',marginTop:'20px'}}>
                    <div style={{display: 'flex', alignItems: 'center'}}>{createTimeRequired ? <span style={{color:'red',marginRight:'5px'}}>*</span> : null}{createTimeKey}:</div>
                    <div  style={{ }}>
                        {operation==='details'?<div  style={{ width:'100%' }}> {clue&&moment(clue[createTimeParam]).format('YYYY-MM-DD HH:mm:ss') }</div>:<Input placeholder={ createTimePlaceholder }  value={clue&&clue.replyDate}
                                                                                                                                                                 onChange={(e) => {
                                                                                                                                                                     this.onChange('replyDate', e.target.value)
                                                                                                                                                                 }}/>}
                    </div>
                </div>}
                {objectShow?<div style={{display:'flex',marginTop:"15px"}}>
                    <div style={{width:'100px',}}>{objectRequired ? <span style={{color:'red',marginRight:'5px'}}>*</span> : null}{objectKey}</div>
                    <div style={{ flex:"1",}}>
                        <Table columns={columns} dataSource={this.state.dataSource} pagination={false} />
                    </div>
                </div>:null}

            </div>
        )
    }
    onChange = (key,value) =>{

        this.state.clue[key] = value;
        this.setState({},()=>{
            console.log(this.state.clue)
        })
    };

    fileRemove = (file) => {
        let fileList = this.state.material.enclosureList.filter(item=>{
            return item.uid !== file.uid
        });
        this.state.material.enclosureList = fileList;
        this.setState({});
    };

    handlePreview = (item) => {
        let file = item;
        let index= this.state.material.enclosureList.findIndex((item,index)=>item.uid==file.uid);
        this.setState({fileEditorVisible:true,showIndex:index ,itemFile:item});
    };
    beforeUpload(file) {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
        // let reg=/^{1,100}$/;
        let fileName = file.name;
        if (fileName.length > 100) {
            message.error('图片名称不能超过100个字符');
        }
        if (!isJpgOrPng) {
            message.error('只能上传JPG/PNG文件！');
        }
        return isJpgOrPng && fileName;
    }
    haveFileUplod = false;
    imgHandleChange = (info) => {
        this.haveFileUplod = true;
        console.log(info.file.status);
        let that = this;
        if (info.file.response && info.file.response.storageFile && info.file.response.storageFile.suffix && info.file.originFileObj) {
            let ext = info.file.response.storageFile.suffix;
            if (PIC_TYPE.indexOf(ext) !== -1) {
                // 获取图片像素start
                let reader = new FileReader();
                reader.readAsDataURL(info.file.originFileObj);
                reader.onload = (e) => {
                    let img = new Image();
                    img.src = reader.result;
                    // info.file.base64 = reader.result;
                    img.onload = () => {
                        let width = img.width;
                        let height = img.height;
                        info.file.width = width;
                        info.file.height = height;
                        that.setInfoList(info.file, info.fileList);
                    }
                };// 获取图片像素end
            }
            // if ([...VIDEO_TYPE, ...AUDIO_TYPE].indexOf(ext) !== -1) {
            //     // 获取音视频的时长start
            //     let fileurl = URL.createObjectURL(info.file.originFileObj);
            //     let audioElement = new Audio(fileurl);
            //     audioElement.addEventListener('loadedmetadata', function (e) {
            //         let duration = audioElement.duration;
            //         // let second = moment.duration(duration * 1000);
            //         console.log([second.hours(), second.minutes(), second.seconds()].join(':'));
            //         info.file.duration = [second.hours(), second.minutes(), second.seconds()].join(':');
            //         that.setInfoList(info.file, info.fileList);
            //     });
            //     // 获取音视频的时长end
            // }
        }

        // 获取文件base64start
        // let file = new FileCountLimiter(info.file.originFileObj);
        // let reader = new
        // 获取文件base64end


        if (info.file.status === 'done') {
            that.setInfoList(info.file, info.fileList);
            info.file.percent = 100;
            if (info.file.response.status === 200 && info.file.response.data) { // 分片
                this.checkStatusZip(info.file.response.data, () => {
                }, (data) => { // 查看分片完成
                    // let params = {
                    //     url: data.storageFile.path,
                    //     resourceName: data.storageFile.name,
                    //     fileMd5: data.storageFile.md5,
                    //     md5: data.storageFile.md5,
                    //     size: data.storageFile.size,
                    //     // taskId: this.state.taskId,
                    //     type: this.state.fileType,
                    //     // taskMenuId: this.state.menuId,
                    //     fid: this.state.currentId,
                    //     account:this.state.account,
                    // };
                })
            }
            if (info.file.response.success) { // 非分片
                // let params = {
                //     url: info.file.response.storageFile.path,
                //     resourceName: info.file.response.storageFile.name,
                //     fileMd5: info.file.response.storageFile.md5,
                //     md5: info.file.response.storageFile.md5,
                //     size: info.file.response.storageFile.size,
                //     // taskId: this.state.taskId,
                //     type: this.state.fileType,
                //     // taskMenuId: this.state.menuId,
                //     fid: this.state.currentId,
                //     account:this.state.account,
                // };
            }
        }
        this.haveFileUplod = info.fileList.some(item => item.status != 'done');
        // this.state.material.enclosureList = info.fileList;
        this.setState({})
    };

    setInfoList = (file, fileList) => {
        /**获取及接收上传文件的数据 start*/
        let {enclosureAuthor, enclosureCreateTime} = this.sysConfig;
        fileList = fileList.map(item => {
            if (item.uid === file.uid) {
                item.uid = file.uid;
                item.ext = file.response && file.response.storageFile && file.response.storageFile.suffix;
                item.url = file.response && file.response.storageFile && file.response.storageFile.path;
                item.path = file.response && file.response.storageFile && file.response.storageFile.path;
                item.name = file.response && file.response.storageFile && file.response.storageFile.name;
                // item.type = this.state.fileType === 2 ? "picture" : this.state.fileType === 3 ? 'video' : 'attachment';
                item.isChunk = false;
                item.width = file.width;
                item.height = file.height;
                item.status = file.status;
                item.percent = file.percent && file.percent;
                item.duration = file.response && file.response.storageFile && file.response.storageFile.duration;
                item.resourceId = file.response && file.response.storageFile && file.response.storageFile.resourceId;
                item.creatTime = new Date().valueOf();
                item.account = window.top.currentUser.name;
                item.departmentValue = this.state.departmentValue;//部门
                item.pageName = this.sysConfig['pageName'];
                item.duration = file.duration; // 时长
                // item.base64 = info.file.base64;
                item.tagValue = '';
                // item.tagList = new Array(...(this.state.material.tagList || []));
                // if (this.sysConfig.accessoryNameShow) {
                //     item[enclosureAuthor] = this.state.material.enclosureAuthor;
                // }
                // if (this.sysConfig.accessoryTimeShow) {
                //     item[enclosureCreateTime] = this.state.material.enclosureCreateTime;
                // }
            }
            return item;
        });
        // this.state.material.enclosureList = fileList;
        this.setState({});
        /**获取及接收上传文件的数据 start*/
    }

    //压缩包上传 检查上传之后的状态，视频有的时候需要查看是否合并完成了
    checkStatusZip(md5, ingCallBack, overCallBack) {
        setTimeout(() => {
            checkFileStatus(md5).then(res => {
                if (res.state !== "mergeComplete") {
                    this.checkStatusZip(md5, ingCallBack, overCallBack);
                    ingCallBack(res.stateStr);
                } else {
                    overCallBack(res);
                }
            }).catch(() => {
                overCallBack();
            });
        }, 100);//每隔一秒钟进行检查一次
    }



    onOk=()=>{
        let btn2=this.sysConfig.btn2||{};
        this.save(btn2)

    };
    temp=()=>{
        let btn1=this.sysConfig.btn1||{};
        this.save(btn1)
    }

    save(btn) {
        let { titleParam,contactsParam,contentParam, submitterParam,submitDateParam,contactsWayParam,clueTypeParam,isInterviewParam,resourcePicturesParam,resourceVideosParam,attachmentPicturesParam,

        } = this.sysConfig;
        let sysConfig = this.sysConfig;
        let url = btn.requestUrl || '';
        let contentType = btn.contentType ||"json";
        let body = {};
        let method = btn.requestMethod || 'get';
        if (url) {

            let customRequestId = btn.customRequestId || '';
            if(customRequestId&&this.props.record){
                url=url+this.props.record.id;
            }
            //标题
            if (titleParam && sysConfig['titleShow']) {
                if (!this.state.clue.title && sysConfig['titleRequired']) return message.warning(sysConfig['titlePlaceholder'] || '请填写标题！');
                body[titleParam] = this.state.clue.title;
            }

            //联系人
            if (contactsParam && sysConfig['contactsShow']) {
                if (!this.state.clue.contacts && sysConfig['contactsRequired']) return message.warning(sysConfig['contactsPlaceholder'] || '请填写联系人！');
                body[contactsParam] = this.state.clue.contacts;
            }
            //联系电话
            if (contactsWayParam && sysConfig['contactsWayShow']) {
                if (!this.state.clue.contactsWay && sysConfig['contactsWayRequired']) return message.warning(sysConfig['contactsWayPlaceholder'] || '请填写联系人电话！');
                body[contactsWayParam] = this.state.clue.contactsWay;
            }

            //线索内容
            if (contentParam && sysConfig['contentShow']) {
                if (!this.state.clue.content && sysConfig['contentRequired']) return message.warning(sysConfig['contentPlaceholder'] || '请填写内容！');
                body[contentParam] = this.state.clue.content;
            }
            //当前用户
            let account = window.top.currentUser.account;
            body[submitterParam] = account;

            //当前时间
            let approvalTimeKey = submitDateParam||"submitDate"
            if (approvalTimeKey) { //审批时间
                body[approvalTimeKey] = new Date().getTime();
            }
            let statusParam = btn.statusParam;
            let statusKey = btn.statusKey
            // 1、线索 2、选题
            body[clueTypeParam] = 1;
            body[statusParam] = statusKey;
            body[isInterviewParam] = 0;
            body[resourcePicturesParam]=[];
            body[resourceVideosParam]=[];
            body[attachmentPicturesParam]=[]


            //线索图片
            // if (resourcePicturesParam && sysConfig['resourcePicturesShow']) {
            //     if (!this.state.clue.resourcePictures.length && sysConfig['resourcePicturesRequired']) return message.warning( sysConfig['resourcePicturesText']||"请上传线索图片");
            //     body[resourcePicturesParam] = this.state.clue.resourcePictures||[];
            // }
            // //线索视频
            // if (resourceVideosParam && sysConfig['resourceVideosShow']) {
            //     if (!this.state.clue.resourcePictures.length && sysConfig['resourceVideosRequired']) return message.warning( sysConfig['resourceVideosText']||"请上传线索视频");
            //     body[resourceVideosParam] = this.state.clue.resourceVideos||[];
            // }
            // //线索图片
            // if (attachmentPicturesParam && sysConfig['attachmentPicturesShow']) {
            //     if (!this.state.clue.resourcePictures.length && sysConfig['attachmentPicturesRequired']) return message.warning( sysConfig['attachmentPicturesText']||"请上传线索图片");
            //     body[attachmentPicturesParam] = this.state.clue.attachmentPictures||[];
            // }
            //let
            console.log(body, 'body---------------')
            request({url:url, contentType:contentType, body,  method, callBack:(data)=>{
                    console.log(data)
                    this.complete();
                }});

        } else {
            this.complete();
        }
    }

}
